<template>
  <header class="main-header">
    <!-- Logo -->
    <a href="\" class="logo">
      <!-- mini logo for sidebar mini 50x50 pixels -->
      <span class="logo-mini"><b>H</b>Care</span>
      <!-- logo for regular state and mobile devices -->
      <span class="logo-lg"><b>Hotline</b>.CARE</span>
    </a>

    <!-- Header Navbar: style can be found in header.less -->
    <nav class="navbar navbar-static-top">
      <!-- Sidebar toggle button-->
      <a href="#" class="sidebar-toggle" data-toggle="push-menu" role="button">
        <span class="sr-only">Toggle navigation</span>
      </a>
      <!-- Navbar Right Menu -->
      <div class="navbar-custom-menu">

        <ul class="nav navbar-nav">
          <!-- Messages: style can be found in dropdown.less-->
          
         <li class="dropdown">
                  <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false">
                    <span :title="selectedLan" :class="classFlag"></span>
                  
                  <span class="caret"></span></a>
                      <ul class="dropdown-menu" role="menu">
                          

                          <li v-for="entry in languages" :key="entry.title">
                           <a href='#'  @click="changeLocale(entry)"><flag :iso="entry.flag" v-bind:squared=false /> {{entry.title}}</a>
                          </li>
                      </ul>
                </li>
          <li class="dropdown messages-menu">

            <a href="#" class="dropdown-toggle" data-toggle="dropdown">
              <i class="fa fa-envelope-o"></i>
              <span class="label label-success">0</span>
            </a>
            <ul class="dropdown-menu">
              <li class="header">You have 0 messages</li>
              <li>
                <!-- inner menu: contains the actual data -->
                <ul class="menu">
                 
                </ul>
              </li>
              <li class="footer"><a href="#">See All Messages</a></li>
            </ul>
          </li>
          <!-- Notifications: style can be found in dropdown.less -->
          <li class="dropdown notifications-menu">
            <a href="#" class="dropdown-toggle" data-toggle="dropdown">
              <i class="fa fa-bell-o"></i>
              <span class="label label-warning">{{ unreadNotificationsCount }}</span>
            </a>
            <ul class="dropdown-menu">
              <li class="header">You have {{ unreadNotificationsCount }} notifications</li>
              <li>
                <!-- inner menu: contains the actual data -->
                <ul class="menu">
                  <li>
                    <a href="#">
                      <i class="fa fa-users text-aqua"></i> 5 new members joined today
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i class="fa fa-warning text-yellow"></i> Very long description here that may not fit into the
                      page and may cause design problems
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i class="fa fa-users text-red"></i> 5 new patient joined
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i class="fa fa-shopping-cart text-green"></i> 25 ration requested today
                    </a>
                  </li>
                  
                </ul>
              </li>
              <li class="footer"><a href="#">View all</a></li>
            </ul>
          </li>
          <!-- Tasks: style can be found in dropdown.less -->
          <li class="dropdown tasks-menu">
            <a href="#" class="dropdown-toggle" data-toggle="dropdown">
              <i class="fa fa-flag-o"></i>
              <span class="label label-danger">{{ remainTasksCount }}</span>
            </a>
            <ul class="dropdown-menu">
              <li class="header">You have {{ remainTasksCount }} tasks</li>
              <li>
                <!-- inner menu: contains the actual data -->
                <ul class="menu">
                  <li><!-- Task item -->
                    <a href="#">
                      <h3>
                        Patient with Minor symptoms
                        <small class="pull-right">20%</small>
                      </h3>
                      <div class="progress xs">
                        <div class="progress-bar progress-bar-aqua" style="width: 20%" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100">
                          <span class="sr-only">20% </span>
                        </div>
                      </div>
                    </a>
                  </li>
                  <!-- end task item -->
                  <li><!-- Task item -->
                    <a href="#">
                      <h3>
                        Patient with Major symptoms
                        <small class="pull-right">40%</small>
                      </h3>
                      <div class="progress xs">
                        <div class="progress-bar progress-bar-green" style="width: 40%" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100">
                          <span class="sr-only">40% </span>
                        </div>
                      </div>
                    </a>
                  </li>
                  <!-- end task item -->
                  <li><!-- Task item -->
                    <a href="#">
                      <h3>
                        Unrecognized 
                        <small class="pull-right">40%</small>
                      </h3>
                      <div class="progress xs">
                        <div class="progress-bar progress-bar-red" style="width: 60%" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100">
                          <span class="sr-only">40% </span>
                        </div>
                      </div>
                    </a>
                  </li>
                  <!-- end task item -->
                 
                  <!-- end task item -->
                </ul>
              </li>
              <li class="footer">
                <a href="#">View all tasks</a>
              </li>
            </ul>
          </li>
          <!-- User Account: style can be found in dropdown.less -->
          <li class="dropdown user user-menu">
            <a href="#" class="dropdown-toggle" data-toggle="dropdown">
              <img :src="avatar" class="user-image" alt="User Image">
              <span class="hidden-xs">{{ currentUser.name }}</span>
            </a>
            <ul class="dropdown-menu">
              <!-- User image -->
              <li class="user-header">
                <img :src="avatar" class="img-circle" alt="User Image">

                <p>
                  {{ currentUser.name }} - {{ $t('userType')[[currentUser.position-1]]  }}
                  <small>{{ currentUser.createdAt }}</small>
                </p>
              </li>
              <!-- Menu Body -->
            
              <!-- Menu Footer-->
              <li class="user-footer">
                <div class="pull-left">
                  <a href="/profile" class="btn btn-default btn-flat">{{$t('profile')}}</a>
                </div>
                <div class="pull-right">
                  <a href="/logout" class="btn btn-default btn-flat">{{$t('sign_out')}}</a>
                </div>
              </li>
            </ul>
          </li>
          <!-- Control Sidebar Toggle Button -->
          <li>
            <a href="#" data-toggle="control-sidebar"><i class="fa fa-gears"></i></a>
          </li>
        </ul>
      </div>
    </nav>
  </header>
</template>

<script>
import { mapGetters , mapActions } from 'vuex'
import i18n from './plugins/i18n'
import config from '../src/vuex/api/services/config'
export default {
  name: 'va-navibar',
   data() {
            return {
                languages: [
                    { flag: 'us', language: 'en', title: 'English' },
                    { flag: 'es', language: 'es', title: 'Español' },
                    { flag: 'my', language: 'my', title: 'Malaysia' }
                ],
                selectedLan: '',
                classFlag: '',
                title: '',
                avatar :''
            }
        },
     mounted (){
        this.avatar = config.serverURI + '/avatar/' + this.currentUser.contactNumber 
     },
     created () {
     this.getLanguage()
      this.selectedLan = this.lang.language
      this.classFlag = 'flag-icon flag-icon-' + this.lang.flag
      this.title = this.lang.title
   },
    methods: 
    {
      imageLoadError :function(event){
       console.log(event)
       event.target.src = config.serverURI + '/static/avatar.png'  
    },
       ...mapActions([
      'getLanguage',
      'setLanguage'
    ]),
      changeLocale(locale) {
        this.setLanguage(locale)
        i18n.locale = locale.language
         this.selectedLan = locale.language
         this.classFlag = 'flag-icon flag-icon-' + locale.flag
         this.title = locale.title
      }
      
    },
  computed: {
    ...mapGetters([
      'unreadMessagesCount',
      'unreadNotificationsCount',
      'remainTasksCount',
      'currentUser',
      'lang'
    ])
  }
}

</script>



// WEBPACK FOOTER //
// NaviBar.vue?51ed0728